module.exports = __webpack_public_path__ + "static/maarif2-8448943a92d60209e82eefacb3ad1cb8.png";